import { render, staticRenderFns } from "./CustomCheckboxPersonal.vue?vue&type=template&id=676f84bc&"
import script from "./CustomCheckboxPersonal.vue?vue&type=script&lang=js&"
export * from "./CustomCheckboxPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports